import { Avatar, Descriptions, Divider, Drawer } from "antd";
import parse from "html-react-parser";

import moment from "moment";

function ViewDetail(props: any) {
  let { openViewDetail, setOpenViewDetail, dataViewDetail } =
    props;
  const onClose = () => {
    setOpenViewDetail(false);
  };
  return (
    <>
      <Drawer
        title="Chức năng xem chi tiết"
        width={"50vw"}
        onClose={onClose}
        open={openViewDetail}>
        <Descriptions title="Thông tin bài viết" bordered column={2}>
          <Descriptions.Item label="ID">
            {dataViewDetail?._id}
          </Descriptions.Item>
          <Descriptions.Item label="Thể loại">
            {dataViewDetail?.categoryId?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Tiêu đề" span={2}>
            {dataViewDetail?.title}
          </Descriptions.Item>
          <Descriptions.Item labelStyle={{minWidth: "110px"}} label="Miêu tả"  span={2} className={`html_react_parser`}>
            {parse(dataViewDetail?.description || "")}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {moment(dataViewDetail?.createdAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày cập nhật">
            {moment(dataViewDetail?.updatedAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
        </Descriptions>

        <Divider orientation="left">Ảnh bài viết</Divider>
        <Avatar shape="square" size={200} src={dataViewDetail?.image} />
      </Drawer>
    </>
  );
}

export default ViewDetail;
